export class ApartmentsGroup {
    id: string;
    name: string;
    listOfApartments: Array<string>;
}
